import { IPassiveSkill } from "../ISkill";
import CharacterAttributes from "../../Character/CharacterAttributes";

export default class ManaRegenSkill implements IPassiveSkill {
  Name = "Mana Flow";
  Description = "Increases mana regeneration rate.";
  MaxLevel = 5;
  IconKey = "skill_mana_flow";

  ApplyBonus(level: number, attributes: CharacterAttributes): void {
    attributes.Intelligence += level * 2;
  }
}
